import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { ProjectTransferSuccess } from 'src/app/core/models/ProjectTransferSuccess';
import { SharedService } from '../shared.service';

@Component({
  standalone: false,
  selector: 'fdb-project-transfer-success',
  templateUrl: './project-transfer-success.component.html',
  styleUrls: ['./project-transfer-success.component.scss']
})
export class ProjectTransferSuccessComponent {
  public UIControlTyp = UIControlTyp;
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.ProjectTransferSuccesses.map(unit => Number(unit.id)) :
      Number(this.ProjectTransferSuccess.id);
    return val;
  }
  set values(val: string | number | number[]) {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.ProjectTransferSuccesses = (val as number[]).map(id => this.getObjectFromList(id));
    } else {
      this.ProjectTransferSuccess = this.getObjectFromList(Number(val));
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public ProjectTransferSuccesses: ProjectTransferSuccess[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public ProjectTransferSuccess: ProjectTransferSuccess;
  /** Enthält die Werte die angezeigt werden dürfen */
  public ProjectTransferSuccessList: ProjectTransferSuccess[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: ProjectTransferSuccess[] = [];

  constructor(private modulService: SharedService) { this.initProjectTransferSuccess(); }

  initProjectTransferSuccess() {
    this.modulService.getTransferSuccesses()
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.ProjectTransferSuccessList = this.OriginalValues.filter(s => s.isActive === true);
          if (this.uiController === UIControlTyp.DropDownList) {
            this.ProjectTransferSuccessList.unshift(new ProjectTransferSuccess().getEmptyModel());
          }
          if (this.uiController === UIControlTyp.MultiSelectList) {
            this.getRefreshSelectedValue();
          }
        }
      },
        err => this.modulService.showNotification(err, 'error'));
  }

  filterenbwunit(value: string) {
    this.ProjectTransferSuccessList = this.OriginalValues
      .filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(): void {
    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: number): ProjectTransferSuccess {
    if (id === 0) { return new ProjectTransferSuccess().getEmptyModel(); }
    const find = this.OriginalValues.find(unit => unit.id === id);
    return find ? find : new ProjectTransferSuccess().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.ProjectTransferSuccess.id));
    return find ? find.name : '';
  }
  getRefreshSelectedValue() {
    this.ProjectTransferSuccesses = this.ProjectTransferSuccesses.map(x => this.OriginalValues.find(y => y.id === x.id));
  }
}
